import { installReviewWidgetGlobalApi } from './widget'
import { installGoogleReviewWidgetGlobalApi } from './google-widget'

export * from './widget'
export * from './google-widget'

installReviewWidgetGlobalApi()
installGoogleReviewWidgetGlobalApi()

